module.exports = __webpack_public_path__ + "assets/src/style/img/footer-rug-campus-fryslan.png?dac4f3408b61ec5e4590aa592047217a";